export const CREATORS = ['ryunokomachi'] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  ryunokomachi: 'marvelRivals1',
}

export const mapCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
  }
> = {
  ryunokomachi: {
    profileCardImageURL: '/static/images/profiles/marvelRivals1/0.jpeg',
  },
}

const VANGUARD_IMAGES = Array(8)
  .fill(0)
  .map((_, i) => `/static/images/characters/marvelRivals1/v_${i}.png`)

const DUELIST_IMAGES = Array(19)
  .fill(0)
  .map((_, i) => `/static/images/characters/marvelRivals1/d_${i}.png`)

const STRATEGIST_IMAGES = Array(8)
  .fill(0)
  .map((_, i) => `/static/images/characters/marvelRivals1/s_${i}.png`)

export const characterGroups = {
  vanguard: {
    title: 'ヴァンガード',
    images: VANGUARD_IMAGES,
    startIndex: 0,
  },
  duelist: {
    title: 'デュエリスト',
    images: DUELIST_IMAGES,
    startIndex: VANGUARD_IMAGES.length,
  },
  strategist: {
    title: 'ストラテジスト',
    images: STRATEGIST_IMAGES,
    startIndex: VANGUARD_IMAGES.length + DUELIST_IMAGES.length,
  },
}

export const ALL_CHARACTER_IMAGES = [
  ...VANGUARD_IMAGES,
  ...DUELIST_IMAGES,
  ...STRATEGIST_IMAGES,
]

export const creatorMapCharacters: Record<CREATOR, string[]> = {
  ryunokomachi: ALL_CHARACTER_IMAGES,
}
